export default __webpack_public_path__ + "static/Q6_3_SmallDog-eb38a6658aa07faa7a26711e25a03ff2.svg";